import {
  LayoutSubSidebar,
  LayoutSubHeader,
  LayoutPageTitle,
} from '@/features/layout';
import styles from './Empty.module.css';

export default function Empty() {
  return (
    <>
      <LayoutPageTitle title="SubSideBar" />
      <LayoutSubSidebar title="SubSideBar">
        <div className={styles.navItem}>Item 1</div>
        <div className={styles.navItem}>Item 2</div>
        <div className={styles.navItem}>Item 3</div>
      </LayoutSubSidebar>
      <LayoutSubHeader title="SubHeader" />
      <main className={styles.content}>
        <h1>Empty Page</h1>
        <p>Main content goes here</p>
      </main>
    </>
  );
}
